import { IActionItems, IStatus } from './../../pages/home/components/transition/transition.interface';
import {  Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'action-details-modal',
  templateUrl: './action-details-modal.component.html',
  styleUrls: ['./action-details-modal.component.scss']
})
export class ActionDetailsModalComponent implements OnInit, OnDestroy {
  private subscription!: Subscription;
  public userDetails: any;
  @Input() data: any = {
    itemHeader: '',
    items: []
  };
  constructor( public userService: UserService,) { }
  
  ngOnInit(): void {
    this.userDetails = this.userService.userDetails;
    
  }
  ngOnDestroy(): void {
    // this.subscription.unsubscribe();
  }

 
}
